import {createReducer} from 'typesafe-actions';
import {
  TSetWebEditorJobAction,
  TSetWebEditorJobState,
} from 'modules/setWebEditorJob/types';
import {setWebEditorJobAction} from 'modules/setWebEditorJob/actions';
import {
  asyncState,
  createAsyncReducer,
  transformToArray,
} from 'lib/reducerUtils';

const initialState: TSetWebEditorJobState = {
  savePost: asyncState.initial(),
};

const setWebEditorJob = createReducer<
  TSetWebEditorJobState,
  TSetWebEditorJobAction
>(initialState).handleAction(
  transformToArray(setWebEditorJobAction),
  createAsyncReducer(setWebEditorJobAction, 'savePost'),
);

export default setWebEditorJob;
